/**
 * Copyright (c) 2022 Wizart Animation.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Wizart Animation.
 */

import { combineReducers } from "redux";
import DEFAULT_ENTITY_DISPLAY_NAMES from "../constants/defaultEntityDisplayNames";
import { getShowRightSideBarFromLocalStore } from "functions/setGetShowRightSideBarLocalStore";

import {
    UPDATE_WD_COMMANDS,
    UPDATE_SCHEMA,
    UPDATE_PROJECT_SCHEMA,
    UPDATE_PERMISSIONS,
    CONTENT_TYPES,
    SET_USERNAME,
    SET_USERAVATAR,
    SET_IS_FREELANCER,
    SET_RAW_DATA,
    SET_USER_ID,
    SET_USER_IS_STAFF,
    SET_USER_IS_SUPERUSER,
    USER_IS_AUTHENTICATED,
    SET_USER_FULLNAME,
    SET_IS_SERIES,
    SIDE_BAR_RIGHT_DETAIL_VIEW_SHOW,
    SIDE_BAR_LEFT_SHOW,
    SIDE_BAR_LEFT_WIDTH,
    SET_TASK_FILTER,
    SET_ENTITY_CONTEXT,
    SET_SELECTED_FILTER_ITEMS,
    SIDE_BAR_RIGHT_QUICK_FILTER_SHOW,
    QUICK_FILTER_APPLY,
    SET_QUICK_FILTER_DATA,
    SET_QUICK_FILTER,
    SET_ENTITY_DISPLAY_NAMES,
    SET_VERSION_REVIEW_ATTACHMENTS,
    SET_SELECTED_MARKER_ID,
    SET_VIDEO_PLAYER_TIME_FORMAT,
    SET_CUSTOM_CONTEXT_MENU_ITEMS,
    SET_IS_DARK,
    FEATURE_FLAGS,
    SITE_PREFERENCES,
    NEW_UPDATE_PERMISSIONS,
    DETAILVIEW_MODE_SIDEBAR_WIDTH,
    NOTIFICATIONS_COUNTER,
    CLOSE_NOTE_STATUS,
    CAN_DOWNLOAD_VIDEO,
} from "./actions/actionTypes";

const wizartDesktopCommands = function (state = [], action) {
    switch (action.type) {
        case UPDATE_WD_COMMANDS:
            return action.wizartDesktopCommands;
        default:
            return state;
    }
};

const schema = function (state = {}, action) {
    switch (action.type) {
        case UPDATE_SCHEMA:
            return action.schema;
        default:
            return state;
    }
};

const projectSchema = function (state = null, action) {
    switch (action.type) {
        case UPDATE_PROJECT_SCHEMA:
            return action.projectSchema;
        default:
            return state;
    }
};

const permissions = function (state = [], action) {
    switch (action.type) {
        case UPDATE_PERMISSIONS:
            return action.permissions;
        default:
            return state;
    }
};

const newPermissions = function (state = {}, action) {
    switch (action.type) {
        case NEW_UPDATE_PERMISSIONS:
            return action.newPermissions;
        default:
            return state;
    }
};

const contentTypes = (state = [], { type, value = Map }) => {
    switch (type) {
        case CONTENT_TYPES:
            return value;
        default:
            return state;
    }
};

const username = function (state = "", action) {
    switch (action.type) {
        case SET_USERNAME:
            return action.username;
        default:
            return state;
    }
};

const useravatar = function (state = "", action) {
    switch (action.type) {
        case SET_USERAVATAR:
            return action.useravatar;
        default:
            return state;
    }
};

const is_freelancer = function (state = false, action) {
    switch (action.type) {
        case SET_IS_FREELANCER:
            return action.is_freelancer;
        default:
            return state;
    }
};

const rawData = (state = {}, action) => {
    switch (action.type) {
        case SET_RAW_DATA:
            return action.rawData;
        default:
            return state;
    }
};

const userId = (state = 0, action) => {
    switch (action.type) {
        case SET_USER_ID:
            return action.id;
        default:
            return state;
    }
};

const userIsStaff = (state = false, action) => {
    switch (action.type) {
        case SET_USER_IS_STAFF:
            return action.isStaff;
        default:
            return state;
    }
};

const userIsSuperuser = (state = false, action) => {
    switch (action.type) {
        case SET_USER_IS_SUPERUSER:
            return action.isSuperuser;
        default:
            return state;
    }
};
const userIsAuthenticated = (state = false, action) => {
    switch (action.type) {
        case USER_IS_AUTHENTICATED:
            return action.status;
        default:
            return state;
    }
};

const userFullname = (state = "", action) => {
    switch (action.type) {
        case SET_USER_FULLNAME:
            return action.name;
        default:
            return state;
    }
};

const projectIsSeries = (state = false, action) => {
    switch (action.type) {
        case SET_IS_SERIES:
            return action.status;
        default:
            return state;
    }
};

const sideBarRightDetailViewShow = (state, action) => {
    switch (action.type) {
        case SIDE_BAR_RIGHT_DETAIL_VIEW_SHOW:
            return action.sideBarRightDetailViewShow;
        default:
            if (typeof state === "undefined")
                return getShowRightSideBarFromLocalStore();
            return state;
    }
};

const sideBarRightQuickFilterShow = (state = false, action) => {
    switch (action.type) {
        case SIDE_BAR_RIGHT_QUICK_FILTER_SHOW:
            return action.sideBarRightQuickFilterShow;
        default:
            return state;
    }
};

const sideBarLeftShow = (state = false, action) => {
    switch (action.type) {
        case SIDE_BAR_LEFT_SHOW:
            return action.sideBarLeftShow;
        default:
            return state;
    }
};

const sideBarLeftWidth = (state = 0, action) => {
    switch (action.type) {
        case SIDE_BAR_LEFT_WIDTH:
            return action.sideBarLeftWidth;
        default:
            return state;
    }
};

const entityFilter = (state = "", action) => {
    switch (action.type) {
        case SET_TASK_FILTER:
            return action.entityFilter;
        default:
            return state;
    }
};

const entityContext = (state = {}, action) => {
    switch (action.type) {
        case SET_ENTITY_CONTEXT:
            return action.entityContext;
        default:
            return state;
    }
};

const selectedFilterItems = (state = [], action) => {
    switch (action.type) {
        case SET_SELECTED_FILTER_ITEMS:
            return action.selectedFilterItems;
        default:
            return state;
    }
};

const quickFilterApply = (state = false, action) => {
    switch (action.type) {
        case QUICK_FILTER_APPLY:
            return action.quickFilterApply;
        default:
            return state;
    }
};

const quickFilterData = (state = {}, action) => {
    switch (action.type) {
        case SET_QUICK_FILTER_DATA:
            return action.quickFilterData;
        default:
            return state;
    }
};

const quickFilter = (state = "", action) => {
    switch (action.type) {
        case SET_QUICK_FILTER:
            return action.quickFilter;
        default:
            return state;
    }
};

const entityDisplayNames = (state = DEFAULT_ENTITY_DISPLAY_NAMES, action) => {
    switch (action.type) {
        case SET_ENTITY_DISPLAY_NAMES:
            return action.entityDisplayNames;
        default:
            return state;
    }
};

const versionReviewAttachments = (state = {}, action) => {
    switch (action.type) {
        case SET_VERSION_REVIEW_ATTACHMENTS:
            return action.attachments;
        default:
            return state;
    }
};

const selectedMarkerId = (state = null, action) => {
    switch (action.type) {
        case SET_SELECTED_MARKER_ID:
            return action.value;
        default:
            return state;
    }
};

const selectedPlayerTimeFormat = (
    state = localStorage.getItem("playerTimeFormat") ?? "frames",
    { type, payload }
) => {
    switch (type) {
        case SET_VIDEO_PLAYER_TIME_FORMAT:
            return payload;
        default:
            return state;
    }
};

const customContextMenuItems = (state = [], action) => {
    switch (action.type) {
        case SET_CUSTOM_CONTEXT_MENU_ITEMS:
            return action.customContextMenuItems;
        default:
            return state;
    }
};

const isDarkTheme = (state = false, action) => {
    switch (action.type) {
        case SET_IS_DARK:
            return action.isDarkTheme;
        default:
            return state;
    }
};
const featureFlags = (state = false, action) => {
    switch (action.type) {
        case FEATURE_FLAGS:
            return action.featureFlags;
        default:
            return state;
    }
};
const sitePreferences = (state = {}, action) => {
    switch (action.type) {
        case SITE_PREFERENCES:
            return action.sitePreferences;
        default:
            return state;
    }
};
const dVModeSidebarWidth = (state = null, action) => {
    switch (action.type) {
        case DETAILVIEW_MODE_SIDEBAR_WIDTH:
            return action.dVModeSidebarWidth;
        default:
            return state;
    }
};

const notificationsCounter = (state = 0, action) => {
    switch (action.type) {
        case NOTIFICATIONS_COUNTER:
            return action.notificationsCounter;
        default:
            return state;
    }
};
const closeNoteStatus = (state = null, action) => {
    switch (action.type) {
        case CLOSE_NOTE_STATUS:
            return action.closeNoteStatus;
        default:
            return state;
    }
};
const canDownloadVideo = (state = false, action) => {
    switch (action.type) {
        case CAN_DOWNLOAD_VIDEO:
            return action.canDownloadVideo;
        default:
            return state;
    }
};

const resultReducer = combineReducers({
    wizartDesktopCommands,
    schema,
    projectSchema,
    permissions,
    newPermissions,
    contentTypes,
    username,
    useravatar,
    is_freelancer,
    rawData,
    userId,
    userIsStaff,
    userIsSuperuser,
    userIsAuthenticated,
    userFullname,
    projectIsSeries,
    sideBarRightDetailViewShow,
    sideBarLeftShow,
    sideBarLeftWidth,
    entityFilter,
    entityContext,
    selectedFilterItems,
    sideBarRightQuickFilterShow,
    quickFilterApply,
    quickFilterData,
    quickFilter,
    entityDisplayNames,
    versionReviewAttachments,
    selectedMarkerId,
    selectedPlayerTimeFormat,
    customContextMenuItems,
    isDarkTheme,
    featureFlags,
    sitePreferences,
    dVModeSidebarWidth,
    notificationsCounter,
    closeNoteStatus,
    canDownloadVideo,
});

export default resultReducer;
